module.exports = __webpack_public_path__ + "static/media/sucesso.b742952e.svg";